"use client";

import styles from "@/styles/cart/settlement.module.scss";
import Image from "next/image";
import Link from "next/link";
import { Button } from "react-vant";

import type { PaymentInfo, DiscountInfo } from "@/types/viewCart";

interface CartSettlementProps {
  selectNum: number;
  paymentInfo: PaymentInfo;
  discountInfo: DiscountInfo;
  paymentLoading: boolean;
  isLogin: boolean;
  isUleeId: boolean;
  setPageDate?: (res: unknown) => void;
  checkoutEvent?: (callBack: () => void) => void;
  handleOpenPaypal?: () => void;
}

const getPositiveDiscountAmount = (value: unknown) => {
  const amount = Number(value);
  return Number.isFinite(amount) && amount > 0 ? amount : 0;
};

export default function CartSettlement({
  selectNum,
  paymentInfo,
  discountInfo,
  isLogin,
  isUleeId,
  checkoutEvent,
  handleOpenPaypal,
}: CartSettlementProps) {
  console.log(isUleeId);
  const couponDiscountAmount = getPositiveDiscountAmount(
    discountInfo?.couponDiscountValue,
  );
  const creditsDiscountAmount = getPositiveDiscountAmount(
    discountInfo?.credits,
  );
  const pointsDiscountAmount = getPositiveDiscountAmount(
    discountInfo?.pointsValue,
  );

  return (
    <div className={styles["comp-cart-settlement"]}>
      <div className={styles["settlement-title"]}>
        Total of {selectNum || 0}{" "}
        {(selectNum || 0) > 1 ? "Products" : "Product"}
      </div>

      <div className={styles["amount-item"]}>
        <div className={styles["amount-title"]}>Sub Total:</div>
        <div className={styles["amount-value"]}>{`$ ${
          paymentInfo.subTotal || "0.00"
        }`}</div>
      </div>

      <div className={styles["amount-item"]}>
        <div className={styles["amount-title"]}>Shipping:</div>
        <div className={styles["amount-value"]}>{`$ ${
          (paymentInfo.shipping &&
            paymentInfo.shipping.toFixed(2).toString()) ||
          "0.00"
        }`}</div>
      </div>

      {/* Coupon Discount */}
      {couponDiscountAmount > 0 && (
        <div className={styles["amount-item"]}>
          <div className={styles["amount-title"]}>Coupon:</div>
          <div className={styles["amount-value"]}>
            - $ {couponDiscountAmount.toFixed(2)}
          </div>
        </div>
      )}

      {/* Credits */}
      {creditsDiscountAmount > 0 && (
        <div className={styles["amount-item"]}>
          <div className={styles["amount-title"]}>Credits:</div>
          <div className={styles["amount-value"]}>
            - $ {creditsDiscountAmount.toFixed(2)}
          </div>
        </div>
      )}

      {/* Points */}
      {pointsDiscountAmount > 0 && (
        <div className={styles["amount-item"]}>
          <div className={styles["amount-title"]}>BestDealsPoints:</div>
          <div className={styles["amount-value"]}>
            - $ {pointsDiscountAmount.toFixed(2)}
          </div>
        </div>
      )}

      <div className={styles["total-amount-item"]}>
        <div className={styles["total-amount-title"]}>Total Amount:</div>

        {typeof paymentInfo.total === "number" &&
          !isNaN(paymentInfo.total) &&
          paymentInfo.total > 0 && (
            <div
              className={styles["total-amount-value"]}
              style={{ color: "#e6415f" }}
            >
              {`$ ${paymentInfo.total.toFixed(2) || "0.00"}`}
            </div>
          )}
      </div>

      <div className={styles["btn-box"]}>
        <Button
          type="primary"
          block
          className={styles["checkout-btn"]}
          disabled={!selectNum || paymentInfo.total <= 0}
          onClick={() =>
            checkoutEvent?.(() => {
              window.location.href = `/checkout${isLogin ? "" : "/express"}`;
            })
          }
        >
          Checkout
        </Button>

        <div className={styles["tips"]}>
          <span>OR</span>
        </div>

        <Image
          width={319}
          height={42}
          alt="paypal"
          src={`${process.env.IMAGE_DOMAIN}/svg/view-cart/icon-paypal.svg`}
          className={styles["express-pay-btn"]}
          onClick={handleOpenPaypal}
        />

        {!!(!isUleeId && (paymentInfo.total || 1) <= 4000) && (
          <>
            {!selectNum || paymentInfo.total <= 0 ? (
              <Image
                width={319}
                height={42}
                alt="afterpay"
                src={`${process.env.IMAGE_DOMAIN}/svg/view-cart/icon-after-pay.svg`}
                className={styles["after-pay-btn"]}
                style={{ marginTop: 14 }}
                onClick={() =>
                  checkoutEvent?.(() => {
                    console.log("afterpay click");
                  })
                }
              />
            ) : (
              <Image
                width={319}
                height={42}
                alt="afterpay"
                id="afterpayBtn"
                src={`${process.env.IMAGE_DOMAIN}/svg/view-cart/icon-after-pay.svg`}
                className={styles["after-pay-btn"]}
                style={{ marginTop: 14 }}
              />
            )}
          </>
        )}

        <Link href="/">
          <div className={styles["continue-shopping"]}>Continue Shopping</div>
        </Link>
      </div>
    </div>
  );
}
